import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { genrateguid } from "./Utils/Helper";
import * as serviceWorker from './serviceWorker';
if (localStorage.getItem("_userdevice") == null) {
    const _userdevice = genrateguid();
    localStorage.setItem("_userdevice", _userdevice);
}

window.addEventListener('beforeinstallprompt', function (e) {
    e.preventDefault();
    return false;
});

ReactDOM.render( <
    App / > ,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();